// variant of src/components/shared/production-listing/component.tsx

import React, { useContext } from 'react'

import { withOptimizely, WithOptimizelyProps } from '@optimizely/react-sdk'
import { Column, Grid } from '@vividseats/vivid-ui-kit'
import ProductionListingRowButton from '@vividseats/vivid-ui-kit/dist/components/production-listing-row/production-listing-row-button'
import NextLink from 'next/link'

import MobileProductionListingRow from '@/components/pages/performer/components/shared/mobile-production-listing-row'
import ProductionListContext from '@/context/productions-list'
import { useAnalytics } from '@/hooks/use-analytics'
import { OPTIMIZELY_EVENT } from '@/optimizely/constants'
import NcaaBasketballVariantProductionListingRow from '@/optimizely/ncaa-regions-feature/components/ncaa-basketball-variant-production-listing-row'
import { useNCAARegionsFeature } from '@/optimizely/ncaa-regions-feature/hooks/use-ncaa-regions-feature'
import type { ProductionListSelectorType } from '@/types/app-types'
import { trackSelectProduction } from '@/utils/analytics'
import { trackEvent } from '@/utils/analytics/ga360'

type Props = ProductionListSelectorType & WithOptimizelyProps

const ProductionListingMobile: React.FC<Props> = ({
    optimizely,
    id,
    isExternal,
    venueName,
    name,
    location,
    date,
    day,
    time,
    href,
    analytics,
    isSellingFast,
    isLowPricesDealsAvailable,
    isHomeOpener,
}) => {
    const {
        selectors: { analyticsSubIds },
    } = useContext(ProductionListContext)

    const [isNCAARegionsMobileFeatureEnabled] = useNCAARegionsFeature()

    const { analyticsId, analyticsPageType } = useAnalytics(...analyticsSubIds)

    const handleClick = () => {
        trackEvent('Production Selection', `${analyticsPageType} Page`, 'All Dates', id, false)
        optimizely?.track(OPTIMIZELY_EVENT.productionLinkClick)

        trackSelectProduction({
            item_list_name: analyticsId,
            index: analytics?.index,
            production: analytics?.production,
        })

        /* istanbul ignore next */
        if (isLowPricesDealsAvailable) {
            optimizely?.track(OPTIMIZELY_EVENT.lowPricesDealsAvailableProductionClick)
        }
    }

    const MobileProductionListingRowComponent = isNCAARegionsMobileFeatureEnabled
        ? NcaaBasketballVariantProductionListingRow
        : MobileProductionListingRow

    const productionListingRow: JSX.Element = (
        <Column p={0.5}>
            <NextLink href={href} passHref>
                <MobileProductionListingRowComponent
                    data-testid={`mobile-production-listing-row-${id}`}
                    date={date}
                    day={day}
                    href={href}
                    isSellingFast={isSellingFast}
                    isLowPricesDealsAvailable={isLowPricesDealsAvailable}
                    isHomeOpener={isHomeOpener}
                    location={location}
                    time={time}
                    venueName={venueName}
                    title={name}
                    onClickCapture={handleClick}
                >
                    <ProductionListingRowButton />
                </MobileProductionListingRowComponent>
            </NextLink>
        </Column>
    )

    return (
        <Grid key={id}>
            {isExternal ? (
                productionListingRow
            ) : (
                <NextLink passHref href={href}>
                    {productionListingRow}
                </NextLink>
            )}
        </Grid>
    )
}

export default withOptimizely(ProductionListingMobile)
